
import React from "react";
import {NavLink} from 'react-router-dom';

const SideNav = (pr) => {
    return (
        <div id="layoutSidenav_nav">
            <nav className="sidenav shadow-right sidenav-light">
                <div className="sidenav-menu">
                    <div className="nav accordion" id="accordionSidenav">
                        <NavLink to="/landingArtist" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-activity"></i></div>
                            Dashboard
                        </NavLink>
                        <NavLink to="/myWishlistArtist" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-suit-heart-fill"></i></div>
                            My Wishlist
                        </NavLink>
                        <NavLink to="/myCartArtist" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-suit-heart-fill"></i></div>
                            My Cart
                        </NavLink>
                        <NavLink to="/myOrdersArtist" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-cart-check-fill"></i></div>
                            My Orders
                        </NavLink>
                        <NavLink to="/artworkArtistAll" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-images"></i></div>
                            My Artwork
                        </NavLink>
                        <NavLink to="/viewProfileArtist" className='nav-link'>
                            <div className="nav-link-icon"><i className="bi bi-cart-check-fill"></i></div>
                            My Profile (Artist)
                        </NavLink>
                       
                    </div>
                </div>

            </nav >
        </div >
    )
}

export default SideNav;